import { render } from "./MyIncommings.vue?vue&type=template&id=b5e50eba&scoped=true"
import script from "./MyIncommings.vue?vue&type=script&lang=js"
export * from "./MyIncommings.vue?vue&type=script&lang=js"

import "./MyIncommings.vue?vue&type=style&index=0&id=b5e50eba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5e50eba"]])

export default __exports__